import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import Rule from '@starbucks-web/pattern-library/lib/components/rule';
import warningSolid from '@starbucks-web/pattern-library/lib/icons/warning-solid';

import H1 from 'shared/app/components/h1';
import messages from './messages';
import { sharedNotificationMessages } from 'shared/app/messages';

const Unsuccessful = ({ communicationPreferencesUrl }) => (
  <React.Fragment>
    <H1 className="pt4 pb1" size="md">
      <FormattedMessage {...messages.heading} />
      <span className="pl2">
        <Icon className="color-red" path={warningSolid} />
      </span>
    </H1>
    <p>
      <FormattedMessage {...sharedNotificationMessages.unexpectedError} />
    </p>
    <Rule className="pt4" weight="thin" />
    <p className="py4 color-textBlackSoft">
      <FormattedMessage {...messages.accountHoldersInfo} />
    </p>
    <Button href={communicationPreferencesUrl} visualStyle="positive">
      <FormattedMessage {...messages.preferencesButton} />
    </Button>
  </React.Fragment>
);

export default Unsuccessful;
